// NOTE: When a new language is added here, fetch-translations script should be modified as well

/**
 * Supported locales/languages in the application
 */
export enum LocaleEnum {
  EN = "en",
  DE = "de",
}

/**
 * Translation files for supported languages
 */
export const translationFiles = {
  en: () => import("./translations/en"),
  de: () => import("./translations/de"),
};
